// extracted by mini-css-extract-plugin
export default {"spinner":"ns7iUaOTcJsq0oYsd5Vr","spin":"Mk7HMxWBOCZja3NGPwkn","light":"tIWi3vbNNya9Q3dx17fQ"};